import React from 'react';
import ReactLoading from 'react-loading';
 
const CsplLoader = ({ type, color ,height , width }) => (
    <ReactLoading type={type} color={color} height={height} width={width} />
);
 
export default CsplLoader;

/* ---types---
blank
balls
bars
bubbles
cubes
cylon
spin
spinningBubbles
spokes */